import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

import Error from '@/components/Error.vue';
import {ProviderStatus} from '@/model/Provider';
import {useStorage} from '@/composables/storage';
import useDetailProviderStore from '@/store/detailProvider';
import {computed} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerDetails',
  setup(__props, { expose: __expose }) {

const store = useDetailProviderStore();
useStorage(
    store,
    (customer) => (customer?.Kundname ? customer.Kundname : 'Firmendetail'),
    (route) => {
      return {KundenNr: parseInt(Array.isArray(route.params.id) ? route.params.id[0] : route.params.id)};
    },
);


const detailTyp = computed(() => {
  switch (store.data?.GroupName) {
    case 'Lieferant':
      return 'Lieferanten-Nr.';
    default:
      return 'Kunden-Nr.';
  }
});

__expose({
  Error,
  ProviderStatus,
  store,
  detailTyp,
});

return (_ctx: any,_cache: any) => {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_action = _resolveComponent("v-list-item-action")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!

  return (!_unref(store).loading && !_unref(store).error)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_list, { lines: "two" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_list_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, { class: "spread" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_unref(store).data?.KundenNr), 1),
                    _createElementVNode("div", null, [
                      (_unref(store).data?.DebitorKto > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(store).data?.DebitorKto), 1))
                        : _createCommentVNode("", true),
                      (_unref(store).data?.KreditorKto > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(store).data?.KreditorKto), 1))
                        : _createCommentVNode("", true)
                    ])
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(_component_v_list_item_subtitle, { class: "spread" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(detailTyp.value), 1),
                    _createElementVNode("div", null, [
                      (_unref(store).data?.DebitorKto > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Debitoren-Konto"))
                        : _createCommentVNode("", true),
                      (_unref(store).data?.KreditorKto > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Kreditoren-Konto"))
                        : _createCommentVNode("", true)
                    ])
                  ], undefined, true),
                  _: 1
                })
              ], undefined, true),
              _: 1
            }),
            _createVNode(_component_v_divider),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).data?.PostAnschrift, (address) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `${address.KundenNr}${address.Plz}${address.Ort}${address.Strasse}${address.Number}`
              }, [
                (address.Strasse)
                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                      key: 0,
                      link: "",
                      href: `https://maps.google.com/?saddr=My+Location&daddr==${address.Strasse}, ${address.Plz} ${address.Ort}`,
                      target: "_blank"
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-map-marker")
                          ], undefined, true),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(address.Strasse), 1)
                          ], undefined, true),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_list_item_subtitle, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(`${address.Plz} ${address.Ort}`), 1)
                          ], undefined, true),
                          _: 2
                        }, 1024)
                      ], undefined, true),
                      _: 2
                    }, 1032, ["href"]))
                  : _createCommentVNode("", true),
                (address.Telefon1)
                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                      key: 1,
                      link: "",
                      href: `tel: '${address.Telefon1}'`
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-phone")
                          ], undefined, true),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(address.Telefon1), 1)
                          ], undefined, true),
                          _: 2
                        }, 1024)
                      ], undefined, true),
                      _: 2
                    }, 1032, ["href"]))
                  : _createCommentVNode("", true),
                (address.Telefon2)
                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                      key: 2,
                      link: "",
                      href: `tel: '${address.Telefon2}'`
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-phone")
                          ], undefined, true),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(address.Telefon2), 1)
                          ], undefined, true),
                          _: 2
                        }, 1024)
                      ], undefined, true),
                      _: 2
                    }, 1032, ["href"]))
                  : _createCommentVNode("", true),
                (address.Email)
                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                      key: 3,
                      link: "",
                      href: `mailto: '${address.Email}'`
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-at")
                          ], undefined, true),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(address.Email), 1)
                          ], undefined, true),
                          _: 2
                        }, 1024)
                      ], undefined, true),
                      _: 2
                    }, 1032, ["href"]))
                  : _createCommentVNode("", true),
                (address.Homepage)
                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                      key: 4,
                      link: "",
                      href: `https://${address.Homepage}`,
                      target: "_blank"
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-web")
                          ], undefined, true),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(address.Homepage), 1)
                          ], undefined, true),
                          _: 2
                        }, 1024)
                      ], undefined, true),
                      _: 2
                    }, 1032, ["href"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_divider)
              ]))
            }), 128)),
            _createVNode(_component_v_list_item, {
              link: "",
              to: {
          name: 'customer_contacts_list',
          params: { id: _unref(store).data?.KundenNr.toString(), name: _unref(store).data?.Kundname },
        }
            }, {
              prepend: _withCtx(() => [
                _createVNode(_component_v_avatar, {
                  size: "32px",
                  color: "primary"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      color: "white",
                      size: "18px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-account-group")
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                })
              ]),
              append: _withCtx(() => [
                _createVNode(_component_v_list_item_action, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-arrow-right")
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Ansprechpartner")
                  ], undefined, true),
                  _: 1
                })
              ], undefined, true),
              _: 1
            }, 8, ["to"]),
            _createVNode(_component_v_list_item, {
              link: "",
              to: {
          name: 'customer_documents',
          params: { id: _unref(store).data?.KundenNr.toString(), name: _unref(store).data?.Kundname },
        }
            }, {
              prepend: _withCtx(() => [
                _createVNode(_component_v_avatar, {
                  size: "32px",
                  color: "primary"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      color: "white",
                      size: "18px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-receipt-text")
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                })
              ]),
              append: _withCtx(() => [
                _createVNode(_component_v_list_item_action, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-arrow-right")
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Dokumente")
                  ], undefined, true),
                  _: 1
                })
              ], undefined, true),
              _: 1
            }, 8, ["to"]),
            _createVNode(_component_v_list_item, {
              link: "",
              to: {
          name: 'contact_histories_list',
          params: { id: _unref(store).data?.KundenNr.toString(), name: _unref(store).data?.Kundname },
        }
            }, {
              prepend: _withCtx(() => [
                _createVNode(_component_v_avatar, {
                  size: "32px",
                  color: "primary"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      color: "white",
                      size: "18px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-file-document-check")
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                })
              ]),
              append: _withCtx(() => [
                _createVNode(_component_v_list_item_action, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-arrow-right")
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Kontakte")
                  ], undefined, true),
                  _: 1
                })
              ], undefined, true),
              _: 1
            }, 8, ["to"])
          ], undefined, true),
          _: 1
        }),
        _createVNode(_component_v_expansion_panels, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_expansion_panel, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_expansion_panel_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(" Vorgänge ")
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(_component_v_expansion_panel_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list, { lines: "two" }, {
                      default: _withCtx(() => [
                        (_unref(store).data?.KundStatus == _unref(ProviderStatus).Kunden || _unref(store).data?.KundStatus == _unref(ProviderStatus).Interessenten)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createVNode(_component_v_list_item, {
                                link: "",
                                to: {
                      name: 'customer_offers_module',
                      params: { id: _unref(store).data?.KundenNr.toString(), name: _unref(store).data?.Kundname },
                    }
                              }, {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_v_avatar, {
                                    size: "32px",
                                    color: "primary"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        color: "white",
                                        size: "18px"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("mdi-file-document")
                                        ], undefined, true),
                                        _: 1
                                      })
                                    ], undefined, true),
                                    _: 1
                                  })
                                ]),
                                append: _withCtx(() => [
                                  _createVNode(_component_v_list_item_action, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("mdi-arrow-right")
                                        ], undefined, true),
                                        _: 1
                                      })
                                    ], undefined, true),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Angebote")
                                    ], undefined, true),
                                    _: 1
                                  })
                                ], undefined, true),
                                _: 1
                              }, 8, ["to"]),
                              _createVNode(_component_v_list_item, {
                                link: "",
                                to: {
                      name: 'customer_tasks_module',
                      params: { id: _unref(store).data?.KundenNr.toString(), name: _unref(store).data?.Kundname },
                    }
                              }, {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_v_avatar, {
                                    size: "32px",
                                    color: "primary"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        color: "white",
                                        size: "18px"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("mdi-file-document-check")
                                        ], undefined, true),
                                        _: 1
                                      })
                                    ], undefined, true),
                                    _: 1
                                  })
                                ]),
                                append: _withCtx(() => [
                                  _createVNode(_component_v_list_item_action, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("mdi-arrow-right")
                                        ], undefined, true),
                                        _: 1
                                      })
                                    ], undefined, true),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Aufträge")
                                    ], undefined, true),
                                    _: 1
                                  })
                                ], undefined, true),
                                _: 1
                              }, 8, ["to"])
                            ], 64))
                          : _createCommentVNode("", true),
                        (_unref(store).data?.KundStatus == _unref(ProviderStatus).Kunden)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createVNode(_component_v_list_item, {
                                link: "",
                                to: {
                      name: 'customer_delivery_notes_module',
                      params: { id: _unref(store).data?.KundenNr.toString(), name: _unref(store).data?.Kundname },
                    }
                              }, {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_v_avatar, {
                                    size: "32px",
                                    color: "primary"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        color: "white",
                                        size: "18px"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("mdi-truck-check")
                                        ], undefined, true),
                                        _: 1
                                      })
                                    ], undefined, true),
                                    _: 1
                                  })
                                ]),
                                append: _withCtx(() => [
                                  _createVNode(_component_v_list_item_action, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("mdi-arrow-right")
                                        ], undefined, true),
                                        _: 1
                                      })
                                    ], undefined, true),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Lieferscheine")
                                    ], undefined, true),
                                    _: 1
                                  })
                                ], undefined, true),
                                _: 1
                              }, 8, ["to"]),
                              _createVNode(_component_v_list_item, {
                                link: "",
                                to: {
                      name: 'customer_bills_module',
                      params: { id: _unref(store).data?.KundenNr.toString(), name: _unref(store).data?.Kundname },
                    }
                              }, {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_v_avatar, {
                                    size: "32px",
                                    color: "primary"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        color: "white",
                                        size: "18px"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("mdi-receipt-text")
                                        ], undefined, true),
                                        _: 1
                                      })
                                    ], undefined, true),
                                    _: 1
                                  })
                                ]),
                                append: _withCtx(() => [
                                  _createVNode(_component_v_list_item_action, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("mdi-arrow-right")
                                        ], undefined, true),
                                        _: 1
                                      })
                                    ], undefined, true),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Rechnungen")
                                    ], undefined, true),
                                    _: 1
                                  })
                                ], undefined, true),
                                _: 1
                              }, 8, ["to"])
                            ], 64))
                          : _createCommentVNode("", true),
                        (_unref(store).data?.KundStatus == _unref(ProviderStatus).Lieferanten)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 2,
                              link: "",
                              to: {
                      name: 'customer_orders_module',
                      params: { id: _unref(store).data?.KundenNr.toString(), name: _unref(store).data?.Kundname },
                    }
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_v_avatar, {
                                  size: "32px",
                                  color: "primary"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      color: "white",
                                      size: "18px"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("mdi-receipt-text")
                                      ], undefined, true),
                                      _: 1
                                    })
                                  ], undefined, true),
                                  _: 1
                                })
                              ]),
                              append: _withCtx(() => [
                                _createVNode(_component_v_list_item_action, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode("mdi-arrow-right")
                                      ], undefined, true),
                                      _: 1
                                    })
                                  ], undefined, true),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Bestellungen")
                                  ], undefined, true),
                                  _: 1
                                })
                              ], undefined, true),
                              _: 1
                            }, 8, ["to"]))
                          : _createCommentVNode("", true)
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                })
              ], undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        })
      ]))
    : (_openBlock(), _createBlock(Error, {
        key: 1,
        module: _unref(store).$id
      }, null, 8, ["module"]))
}
}

})